import React, { } from 'react'

import './Navigation.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { Translates } from '@/services/repository/i18n'

export interface NavigationRow {
  title: string
  path?: string
}

export interface NavigationMenuProps {
  translates: Translates
  path?: NavigationRow[]
  title: string
}


export const NavigationMenu = (props: NavigationMenuProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleGoBack = () => {
    navigate(-1)
  }

  function translateName(name: string) {
    return props.translates.for(`page.${name}.title`)
  }

  const path: NavigationRow[] = [{
    title: translateName('home'),
    path: '/'
  }, ...(props.path || [{
    title: translateName(props.title)
  }])]

  return <div className='nav-menu'>
    <div className='back-btn' onClick={handleGoBack}>
      <i className='svgfont-back' />
    </div>
    {path.map((row, index) => <>
      {index > 0 ? <div>/</div> : null}
      { !row.path || location.pathname === row.path ? <div className='title'>{row.title}</div> : <div className='path-node' onClick={() => navigate(row.path || '/')}>{row.title}</div>}
    </>)}
  </div>
}